export const topBarHeight = "77px";
export const appLoaderHeight = 2;
export const contentMaxWidth = "1920px";
export const savebarHeight = "64px";
export const borderHeight = "1px";
